<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Title</h5>
            </b-col>

            <b-col align="right">
                <b-button @click="addTitle" variant="outline-secondary" size="sm" tabindex="-1">
                        <b-icon-plus></b-icon-plus>
                </b-button>
            </b-col>
        </b-row>

        <b-input-group size="sm"  v-for="(title, index) in component" v-bind:key="index">
            <b-input :ref="'title-' + index"
                     v-model="component[index]"
                     :state="component[index].length ? null : false"
                     :formatter="lowercase"
                     @keyup.enter="addTitle"></b-input>

            <b-input-group-append>
                <b-button size="sm" variant="outline-secondary" @click="removeTitle(index)" tabindex="-1">
                    <b-icon-x></b-icon-x>
                </b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import formatterMixin from "../../mixins/formatter";

    export default {
        name: "Titles",
        props: [ 'titles' ],
        mixins: [ arrayMixin, formatterMixin ],
        created() {
            this.clone(this.titles);
        },
        methods: {
            focusFirstTitle() {
                this.$nextTick(() => {
                    const ref = 'title-0';
                    const inputs = this.$refs[ref];
                    const el = inputs && inputs[0] && inputs[0].$el;
                    if (el && typeof el.focus === 'function') {
                        el.focus();
                    }
                });
            },
            addTitle() {
                this.component.push('');

                this.$nextTick(() => {
                    let ref = 'title-' + (this.component.length - 1);

                    this.$refs[ref][0].$el.focus();
                });
            },
            removeTitle(index) {
                this.component.splice(index, 1);
            }
        }
    }
</script>

<style scoped>
    .input-group-text {
        width: 5rem;
    }
</style>